import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Edit Input Uang Tips ", -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Penerima", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Keterangan", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Jumlah Uang", -1)
const _hoisted_12 = { class: "card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cashierId) = $event)),
          class: "custom-select",
          autocomplete: "off",
          placeholder: "Penerima",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateCashierName($event)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createElementBlock("option", {
              key: user.id,
              value: user.id
            }, _toDisplayString(user.name), 9, _hoisted_6))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.cashierId]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
          class: "custom-select",
          autocomplete: "off",
          placeholder: "Keterangan"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listReason, (val, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: 'list-reason-' + index,
              value: val
            }, _toDisplayString(val), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.description]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.amountDebit) = $event)),
          type: "text",
          class: "form-control",
          autocomplete: "off",
          placeholder: "Jumlah Uang"
        }, null, 512), [
          [_vModelText, _ctx.amountDebit]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "btn btn-light",
        type: "button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.btnBatalClicked && _ctx.btnBatalClicked(...args)))
      }, "Batal"),
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveUangTips && _ctx.saveUangTips(...args)))
      }, _toDisplayString(_ctx.btnSaveText), 1)
    ])
  ]))
}